import { get } from "../../helpers/apiWrapper";

 

export const getCompanyDetails = async (params) => {
  const config = {
    params: params,
  };
  return await get(`/company-details`, config);
};